<app-capital-container [disablePaddings]="true">
    <div class="container-fluid">
        <div class="row">
            <div
                class="col-12 col-lg-5 col-xl-auto blue-background text-white capital-border d-flex align-items-center justify-content-center">
                <div>
                    <p class="capital-title mb-0 mb-lg-4">Módulo <br class="d-none d-lg-block"> Autoatención</p>
                    <span class="capital-subtitle d-none d-xl-block">Actualiza tus datos y accede a certificados en
                        simples pasos.</span>
                </div>
            </div>
            <div class="col-21 col-md welcome-paddings">
                <p class="capital-title m-0 mb-4">Validemos tu identidad</p>
                <p class="welcome-subtitle">Por seguridad, debes seleccionar un método de validación</p>
                <div class="mb-4">
                    <app-capital-button icon="/img/password.svg" title="Clave de Acceso"
                        subtitle="Esta clave es la misma con la que accedes al sitio web."
                        (click)="goLogin()"></app-capital-button>
                </div>
                <div>
                    <app-capital-button icon="/img/face.svg" title="Cédula de identidad y huella"
                        subtitle="Accede escaneando tu cédula de identidad y huella."
                        (click)="goAgile()"></app-capital-button>
                </div>

                <!-- Enlace al catálogo de componentes (solo para desarrollo) -->
                @if (showDevTools) {
                <div class="dev-tools mt-5">
                    <small class="text-muted">Herramientas de desarrollo:</small>
                    <br>
                    <div class="d-flex align-items-center gap-3">
                        <a href="/component-catalog" class="dev-link">📚 Catálogo de Componentes</a>
                        <button class="dev-link console-toggle-btn" (click)="toggleConsoleLog()">
                            {{ isConsoleLogEnabled ? '🟢 Console.log ON' : '🔴 Console.log OFF' }}
                        </button>
                    </div>
                </div>
                }

            </div>
        </div>
    </div>
</app-capital-container>